module.exports = __webpack_public_path__ + "img/1.e45dc13f.jpeg";